<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div class="search_area">
      <div class="container">
        <div class="search_group full">
          <ul class="history">
            <li>
              <a
                :href="`/contents?search_type=${categoryData}`"
                style="color: black"
              >
                {{ categoryData }}
              </a>
            </li>
            <li><img src="/assets/images/icon/history_arrow.png" alt="" /></li>
            <li v-html="detailData.title"></li>
          </ul>
          <div class="search_form">
            <form method="GET">
              <input id="search_type" type="hidden" value="" />
              <input
                id="search_txt"
                v-model="searchTitle"
                type="text"
                class="input"
                value=""
                placeholder="콘텐츠 명을 입력하세요."
                @keydown.enter.prevent="searchContent(searchTitle)"
              />
              <button
                type="button"
                class="submit"
                @click="searchContent(searchTitle)"
              >
                <!-- <button class="submit"> -->
                <img src="/assets/images/icon/search_icon.png" alt="" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 기존 -->
  <div class="container" style="display: none">
    <div class="contents_info">
      <div class="img_group">
        <img :src="detailData.thumbnail" />
      </div>
      <div class="text_group">
        <div class="text_title ellipsis_1" v-html="detailData.title"></div>
        <div class="text_info" v-html="detailData.summary"></div>
        <div class="btn_area">
          <input
            type="button"
            class="btn_orange"
            value="실습하러 가기"
            @click="moveContent"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- 기존 -->

  <!-- 신규-->
  <div v-if="detailData.is_option" class="container">
    <div class="contents_top initOption">
      <div class="con_img">
        <img :src="detailData.thumbnail" />
        <div class="is_order">
          <img src="/assets/images/icon/icon_bag.png" />
          <p>구매가능</p>
        </div>
      </div>
      <div class="con_info">
        <div class="group">
          <div
            class="c_txt"
            v-html="decodeHtmlContent(detailData.summary)"
          ></div>
          <div class="c_title" v-html="detailData.title"></div>
        </div>

        <div class="group select_group">
          <div
            v-if="filteredSubOpts && filteredSubOpts.length !== 0"
            class="opts"
          >
            <div class="opt_title">콘텐츠</div>
            <div class="opt_select">
              <CustomSelectContents
                v-model="selectedSub"
                :options="filteredSubOpts"
                default-option="옵션을 선택하세요."
                @update:selected="(selected) => handleSelect(selected)"
              />
            </div>
          </div>

          <div
            v-if="filteredNotSubOpts && filteredNotSubOpts.length !== 0"
            class="opts"
          >
            <!-- 
              추가옵션 선택 후 구매하기 클릭했을때
              콘텐츠(메인상품) 미 선택한 경우 alert 띄워줘서 콘텐츠과 추가옵션 모두 선택 하여 넘어가도록 수정.
            -->
            <div class="opt_title">추가옵션</div>
            <div class="opt_select">
              <CustomSelectContents
                v-model="selectedNotSub"
                :options="filteredNotSubOpts"
                default-option="옵션을 선택하세요."
                @update:selected="(selected) => handleSelect(selected)"
              />
            </div>
          </div>
          <div v-if="selectedSubOpts.name" class="opts t_b">
            <div class="opt_title l_width" v-html="selectedSubOpts.name"></div>
            <div class="opt_another">
              <div class="opt_cnt">
                <div
                  class="minus dissible"
                  @click="updateQuantity(selectedSubOpts, 'subs', -1)"
                >
                  -
                </div>

                <div v-html="selectedSubOpts.cnt"></div>
                <div
                  class="plus dissible"
                  @click="updateQuantity(selectedSubOpts, 'subs', 1)"
                >
                  +
                </div>
              </div>
              <div class="opt_price">
                <div
                  v-if="selectedSubOpts.disc_rate !== 0"
                  class="percent"
                  v-html="selectedSubOpts.disc_rate + '%'"
                ></div>
                <div v-else class="percent"></div>
                <div class="price_area">
                  <p v-if="selectedSubOpts.disc_rate !== 0">
                    <span v-html="selectedSubOpts.amt.toLocaleString()"></span>
                    원
                  </p>
                  <div v-if="selectedSubOpts.disc_rate !== 0">
                    <!-- <span
                      v-html="selectedSubOpts.disc_amt.toLocaleString()"
                    ></span> -->
                    <span
                      v-html="selectedSubOpts.disc_amt_drt.toLocaleString()"
                    ></span>
                    원
                  </div>
                  <div v-else>
                    <span v-html="selectedSubOpts.amt.toLocaleString()"></span>
                    원
                  </div>
                  <!-- 배송비 노출 -->
                  <div class="show_deliv">
                    <p v-if="selectedSubOpts.delivery_amt !== 0">
                      배송비
                      <span
                        v-html="selectedSubOpts.delivery_amt.toLocaleString()"
                      ></span>
                      원
                    </p>
                  </div>
                </div>
              </div>
              <div class="opt_close" @click="resetSelection('subOpts')">
                <img src="/assets/images/icon/opt_close.png" />
              </div>
            </div>
          </div>
          <div v-if="selectedNotSubOpts.name" class="opts b_b">
            <div
              class="opt_title l_width"
              v-html="selectedNotSubOpts.name"
            ></div>
            <div class="opt_another">
              <div class="opt_cnt">
                <div
                  class="minus"
                  @click="updateQuantity(selectedNotSubOpts, 'notsubs', -1)"
                >
                  -
                </div>
                <div v-html="selectedNotSubOpts.cnt"></div>
                <div
                  class="plus"
                  @click="updateQuantity(selectedNotSubOpts, 'notsubs', 1)"
                >
                  +
                </div>
              </div>
              <div class="opt_price">
                <div
                  v-if="selectedNotSubOpts.disc_rate !== 0"
                  class="percent"
                  v-html="selectedNotSubOpts.disc_rate + '%'"
                ></div>
                <div v-else class="percent"></div>
                <div class="price_area">
                  <p v-if="selectedNotSubOpts.disc_rate !== 0">
                    <span
                      v-html="
                        (
                          selectedNotSubOpts.amt * selectedNotSubOpts.cnt
                        ).toLocaleString()
                      "
                    ></span>
                    원
                  </p>
                  <div v-if="selectedNotSubOpts.disc_rate !== 0">
                    <span
                      v-html="
                        (
                          selectedNotSubOpts.disc_amt_drt *
                          selectedNotSubOpts.cnt
                        ).toLocaleString()
                      "
                    ></span>
                    <!-- <span
                      v-html="
                        (
                          selectedNotSubOpts.disc_amt * selectedNotSubOpts.cnt
                        ).toLocaleString()
                      "
                    ></span> -->
                    원
                  </div>
                  <div v-else>
                    <span
                      v-html="
                        (
                          selectedNotSubOpts.amt * selectedNotSubOpts.cnt
                        ).toLocaleString()
                      "
                    ></span>
                    원
                  </div>
                  <!-- 배송비 노출 -->
                  <div class="show_deliv">
                    <p v-if="selectedNotSubOpts.delivery_amt !== 0">
                      배송비
                      <span
                        v-html="
                          selectedNotSubOpts.delivery_amt.toLocaleString()
                        "
                      ></span>
                      원
                    </p>
                  </div>
                </div>
              </div>
              <div class="opt_close" @click="resetSelection('notSubOpts')">
                <img src="/assets/images/icon/opt_close.png" />
              </div>
            </div>
          </div>

          <div class="total">
            <div class="tt_txt">총 결제금액</div>
            <div class="tt_price">
              {{ totalAmount.toLocaleString() }}<span>원</span>
            </div>
          </div>
        </div>
        <div class="group btn_group">
          <div class="btn_area">
            <div class="btns" @click="moveToUrl('/inquiry')">문의하기</div>
          </div>
          <!-- <div class="btn_area">
            <div class="btns">장바구니</div>
          </div> -->
          <div class="btn_area buy">
            <div class="btns" @click="moveToOrderPage">구매하기</div>
          </div>
          <div v-if="detailData.is_buy" class="btn_area buy">
            <div class="btns gtm_play" @click="moveContent">실습하러 가기</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div v-if="subOpts.length !== 0 || notSubOpts.length !== 0" class="container"> -->
  <!-- 구매 불가능 콘텐츠 -->
  <div v-else class="container">
    <div class="contents_top_noOption">
      <div class="con_img">
        <img :src="detailData.thumbnail" />
      </div>
      <div class="con_info_noOption">
        <div class="group">
          <div
            class="c_txt"
            v-html="decodeHtmlContent(detailData.summary)"
          ></div>
          <div class="c_title" v-html="detailData.title"></div>
          <!-- <div class="c_cp">CP명 </div> -->
        </div>

        <div class="group btn_group">
          <div class="btn_area">
            <div class="btns" @click="moveToUrl('/inquiry')">문의하기</div>
          </div>
          <div class="btn_area buy">
            <div class="btns gtm_play" @click="moveContent">실습하러 가기</div>
          </div>
          <!-- <div>
            <input
              type="button"
              class="btn_orange"
              value="클라이언트 연결"
              @click="metaClientOpen"
            />
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  <!-- 신규-->

  <!-- 탭 -->
  <div class="container">
    <div class="contents_tab">
      <div
        class="tab tab_1 on"
        attr-tab="info"
        @click="moveToId('contentIntroduction')"
      >
        실습소개
      </div>
      <div
        class="tab tab_2"
        attr-tab="query"
        @click="moveToId('contentQuariculum')"
      >
        커리큘럼
      </div>
      <div
        class="tab tab_3"
        attr-tab="notice"
        @click="moveToId('contentNotice')"
      >
        공지사항
      </div>
    </div>
  </div>

  <!-- 실습소개 -->
  <div class="container">
    <div id="contentIntroduction" class="introduction">
      <div class="introduction_area1">
        <div class="text_info_introduce" v-html="decodedDescription"></div>
      </div>
      <div class="introduction_area2">
        <div class="default_set">
          <div class="img_group">
            <img src="/assets/images/icon/icon_area.png" />
          </div>
          <div class="text_group">
            <div class="text_title">이 콘텐츠는 이런 분들에게 추천해요.</div>
            <div v-if="detailData" class="text_info">
              <div v-for="(item, index) in detailData.recommend" :key="index">
                <li v-html="decodeHtmlContent(item)"></li>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="introduction_area3">
        <div class="text_group">
          <div class="text_title">실습 특징</div>
          <div class="text_info">
            <div v-if="detailData.feature" v-html="decodedFeature"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="board_contents none_mt">
    <div id="contentQuariculum" class="container quariculum">
      <div class="board_title">커리큘럼</div>
      <div class="bbs_table_2 not_hover">
        <div
          v-for="(curri, curriIndex) in curriculumData"
          :key="curriIndex"
          class="list_box"
        >
          <div class="img_group_small">
            <img :src="curri.thumbnail" />
          </div>
          <div class="text_group">
            <div class="text_title">{{ decodeHtmlContent(curri.title) }}</div>
            <!-- <div
            v-for="(sub, subIndex) in curri.subtitle"
            :key="subIndex"
            class="text_list"
            > -->
            <div
              v-for="(sub, subIndex) in parseCurriculumDetails(
                curri.crr_detail
              )"
              :key="subIndex"
              class="text_list"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <ContentsNotice />
    <div>
      <ModalAlertContents
        :alert-msg="errMsg"
        :is-open="errStatus"
        :is-cost="errCost"
        :trigger="errTrigger"
        :token-expire="errExpire"
        @update:is-open="updateStatus"
      />
    </div>
    <div>
      <ScrollToTop />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Cookies from 'vue-cookies'
import { loadDetailContent, loadContent } from '../api/boards'
import ContentsNotice from './ContentsNotice.vue'
import CustomSelectContents from './CustomSelectContents.vue'
import ModalAlertContents from './ModalAlertContents.vue'
import ScrollToTop from './ScrollToTop.vue'

export default {
  name: 'ContentsInner',
  components: {
    ContentsNotice,
    CustomSelectContents,
    ModalAlertContents,
    ScrollToTop,
  },
  emits: ['moveContent'],
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)
    const errCost = ref(false)
    const errTrigger = ref('')
    const errExpire = ref(false)
    // eslint-disable-next-line no-undef
    const router = useRouter()

    const route = useRoute()
    const contentsId = ref(null)
    const contentNoticeData = ref(null)
    const cNoticeData = ref([])
    const cNoticePageData = ref([])

    const detailData = ref([])
    const categoryData = ref('')
    const curriculumData = ref([])

    const currentPage = ref()
    const totalPages = ref()

    const orderData = ref()
    const subOpts = ref([])
    const notSubOpts = ref([])
    const selectedSubOpts = ref([])
    const selectedNotSubOpts = ref([])

    const category = ref([])
    const contentList = ref([])
    const searchTitle = ref('')
    const getAT = ref('')
    const checkIsoptions = ref('')
    // eslint-disable-next-line consistent-return
    const getData = async () => {
      if (localStorage.getItem('orderData') !== null) {
        localStorage.removeItem('orderData')
      }
      contentsId.value = route.params.contentsId
      const response = await loadDetailContent(contentsId.value)
      if (response.status_code) {
        if (response.code === 'LT31100200') {
          console.log(response.content)
          console.log('code 찍어보기', response.code)
          console.log(response.content)
          detailData.value = response.content
          categoryData.value = response.content.category.classification
          curriculumData.value = response.content.curriculum.detail
          const options = response.content.option
          console.log('옵션들 >>> ', options)
          checkIsoptions.value = response.content.is_option
          // 각 옵션에 is_subs 추가
          subOpts.value = options.subscription.map((item) => ({
            ...item,
            is_subs: true, // subscription 옵션은 true
          }))
          notSubOpts.value = options.not_subscription.map((item) => ({
            ...item,
            is_subs: false, // not_subscription 옵션은 false
          }))
          return detailData
          // eslint-disable-next-line no-else-return
        } else if (response.code === 'LT31103404') {
          // 로그인 토큰 세션 만료, 로그아웃 시켜주고 보여줘야함.
          // LT31103404
          errStatus.value = true
          errCost.value = false
          errExpire.value = true
          errMsg.value =
            '로그인 시간이 만료되었습니다.<br>구매한 콘텐츠를 확인하려면 다시 로그인 해주세요.'
        } else {
          // 아래 2개의 오류코드는 콘텐츠를 DB에서 찾지 못했거나 정제에 실패했을 경우에 뜨는 에러
          // LT31101404
          // LT31102404
          errStatus.value = true
          errCost.value = false
          errMsg.value =
            '콘텐츠 정보를 찾을 수 없습니다. <br> 오류가 반복되면 서비스 이용 문의를 통해 문의해주세요.'
        }
        // else {
        //   errStatus.value = true
        //   errCost.value = false
        //   errMsg.value = '존재하지 않는 콘텐츠입니다.'
        // }
      }
    }

    const movetoSearchPage = async (page, searchType, Title) => {
      const response = await loadContent(page, searchType, Title)
      // console.log(response)
      // eslint-disable-next-line prefer-destructuring
      category.value = response[0]
      // eslint-disable-next-line prefer-destructuring
      contentList.value = response[1]
      // console.log(contentList.value)
    }

    const searchContent = async (searchItem) => {
      // console.log(searchTitle.value)
      // console.log(searchItem)
      if (searchTitle.value === searchItem) {
        router.push({
          path: '/contents',
          name: 'ContentViews',
          query: {
            search_txt: searchTitle.value,
          },
        })
        movetoSearchPage(0, null, searchItem)
      }
    }
    const parseCurriculumDetails = (detail) => detail.split('\r\n')
    // eslint-disable-next-line no-shadow
    const getIdx = async (contentsId) => {
      router.push(`/contents/${contentsId}`)
    }

    // 일단 운영에 이렇게 반영함.
    // const moveContent = () => {
    //   if (detailData.value.title.includes('CTF')) {
    //     window.location.href = 'https://raonctf.com/'
    //   } else {
    //     emit('moveContent', '라온 메타데미 클라이언트에서 이용해 주세요.')
    //   }
    // }

    /*
    어떻게 다운로드되어서 설치되어있는 사용자와 그렇지 않은 사용자를 구분할 수 있을까?
    지금 log값 찍하는건 동일함.
    심지어 설치해놨던 안 해놨던 '내부 if문 타서 설치 안되어있을때의 경우 실행 됨' 이건 타지도 않음.
    즉, if조건이 지금 다 쓸모가 없음
    startApp을 어떻게 필터링 해야할까? 아니 애초에 window.open으로 설치했는지 안했는지를 구분할 수 있나...???
    */

    const moveContent = async () => {
      if (detailData.value.title.includes('CTF')) {
        window.location.href = 'https://raonctf.com/'
      }
      // eslint-disable-next-line arrow-body-style
      const checkProtocolHandler = () => {
        return new Promise((resolve) => {
          const startApp = window.open('metademy-client:', '_blank')
          try {
            setTimeout(() => {
              if (!startApp.closed) {
                startApp.close()
                errStatus.value = true
                errMsg.value =
                  '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
                errTrigger.value = 'uninstall'
                resolve(false)
              } else {
                startApp.close()
                resolve(true)
              }
            }, 3000)
          } catch (e) {
            errStatus.value = true
            errMsg.value =
              '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
            errTrigger.value = 'uninstall'
          }
        })
      }
      try {
        await checkProtocolHandler()
      } catch (error) {
        console.error('프로토콜 실행 중 오류:', error)
        errStatus.value = true
        errMsg.value =
          '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
        errTrigger.value = 'uninstall'
      }
    }
    // const moveContent = async () => {
    //   if (detailData.value.title.includes('CTF')) {
    //     window.location.href = 'https://raonctf.com/'
    //     return
    //   }

    //   // eslint-disable-next-line arrow-body-style
    //   const checkProtocolHandler = () => {
    //     return new Promise((resolve) => {
    //       // 현재 시간 저장
    //       const startTime = Date.now()

    //       // 프로토콜 실행 시도
    //       window.location.href = 'metademy-client:'

    //       // 프로토콜 핸들러 존재 여부 확인
    //       const checkTimeout = setTimeout(() => {
    //         // 100ms 이내에 핸들러가 실행되지 않으면 설치되지 않은 것으로 판단
    //         if (Date.now() - startTime > 100) {
    //           errStatus.value = true
    //           errMsg.value =
    //             '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //           errTrigger.value = 'uninstall'
    //         }
    //         resolve(false)
    //       }, 100)

    //       // window focus 변화 감지
    //       window.onblur = () => {
    //         clearTimeout(checkTimeout)
    //         window.onblur = null
    //         resolve(true)
    //       }
    //     })
    //   }

    //   try {
    //     await checkProtocolHandler()
    //   } catch (error) {
    //     console.error('프로토콜 실행 중 오류:', error)
    //     errStatus.value = true
    //     errMsg.value =
    //       '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //     errTrigger.value = 'uninstall'
    //   }
    // }

    // const moveContent = async () => {
    //   if (detailData.value.title.includes('CTF')) {
    //     window.location.href = 'https://raonctf.com/'
    //     return
    //   }

    //   // 프로토콜 실행 시도
    //   // eslint-disable-next-line arrow-body-style
    //   const checkInstallation = () => {
    //     return new Promise((resolve) => {
    //       // 설치 확인을 위한 타임아웃
    //       const timeoutId = setTimeout(() => {
    //         // eslint-disable-next-line no-use-before-define
    //         window.removeEventListener('focus', onFocus)
    //         resolve(false) // 설치되지 않음
    //       }, 1000)

    //       // focus 이벤트 리스너
    //       const onFocus = () => {
    //         clearTimeout(timeoutId)
    //         window.removeEventListener('focus', onFocus)
    //         resolve(true) // 설치됨
    //       }

    //       window.addEventListener('focus', onFocus)

    //       // hidden 상태로 새 창에서 프로토콜 실행
    //       const hiddenWindow = window.open(
    //         'metademy-client:',
    //         '_blank',
    //         'width=0,height=0'
    //       )

    //       // 새 창이 차단되었거나 열리지 않은 경우
    //       if (!hiddenWindow) {
    //         clearTimeout(timeoutId)
    //         window.removeEventListener('focus', onFocus)
    //         resolve(false)
    //       }
    //     })
    //   }

    //   try {
    //     const isInstalled = await checkInstallation()

    //     if (!isInstalled) {
    //       errStatus.value = true
    //       errMsg.value =
    //         '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //       errTrigger.value = 'uninstall'
    //     }
    //   } catch (error) {
    //     console.error('프로토콜 실행 중 오류:', error)
    //     errStatus.value = true
    //     errMsg.value =
    //       '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //     errTrigger.value = 'uninstall'
    //   }
    // }

    // const moveContent = async () => {
    //   // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
    //   if (detailData.value.title.includes('CTF')) {
    //     window.location.href = 'https://raonctf.com/'
    //   } else {
    //     // const startApp = window.open('metademy-client:')
    //     const startApp = window.open('metademy-client:', '_blank')

    //     // console.log(startApp)
    //     // console.log(!startApp)
    //     // console.log(startApp.closed)
    //     // console.log(typeof startApp.value)
    //     // console.log(typeof startApp.closed)
    //     // console.log('else문 진입 init else')
    //     try {
    //       setTimeout(() => {
    //         // console.log('setTimeout 진입')
    //         // !startApp || startApp.closed || typeof startApp.closed === 'undefined'
    //         // !startApp.closed
    //         if (!startApp.closed) {
    //           // console.log('내부 if문 타서 설치 안되어있을때의 경우 실행 됨')
    //           startApp.close() // 창을 닫음
    //           errStatus.value = true
    //           errMsg.value =
    //             '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //           errTrigger.value = 'uninstall'
    //         } else {
    //           startApp.close() // 창을 닫음
    //           // console.log('else임~~~~~~~~~~ 설치~~~ 야호~~~~')
    //           // errStatus.value = true
    //           // errMsg.value =
    //           //   '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //           // errTrigger.value = 'uninstall'
    //         }
    //       }, 3000)
    //     } catch (e) {
    //       // console.log('loadErrr')
    //       // // 에러 발생 시 처리
    //       errStatus.value = true
    //       errMsg.value =
    //         '라온 메타데미 클라이언트가 설치되어 있지 않습니다. <br> 다운로드를 먼저 진행해주세요.'
    //       errTrigger.value = 'uninstall'
    //     }
    //   }
    //   // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
    // }

    const moveToId = (sectionId) => {
      const section = document.getElementById(sectionId)
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }

    const moveToUrl = (url) => {
      router.push({ path: url })
    }
    const moveToOrderPage = () => {
      getAT.value = Cookies.get('access_token')

      // 모바일 디바이스 감지 함수
      // eslint-disable-next-line arrow-body-style
      const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      } // 모바일 디바이스일 경우 결제 제한
      if (isMobileDevice()) {
        errStatus.value = true
        errMsg.value =
          '모바일 결제가 제한되었습니다. <br> PC결제로 시도하여주세요.'
        return // 함수 종료
      }
      if (getAT.value !== null) {
        // alert(selectedSubOpts.value.length)
        // eslint-disable-next-line no-use-before-define
        if (totalAmount.value !== 0 && selectedSubOpts.value.length === 0) {
          // console.log(selectedNotSubOpts.value.subs_month)
          console.log(selectedSubOpts.value)
          // eslint-disable-next-line no-use-before-define
          if (selectedNotSubOpts.value.subs_month === 0) {
            orderData.value = {
              contentsIdx: detailData.value.idx,
              contentsTitle: detailData.value.title,
              contentsAmt: detailData.value.amt,
              subOpts:
                selectedSubOpts.value.amt > 0
                  ? selectedSubOpts.value
                  : { idx: 1, cnt: 0, name: '선택안함', amt: 0, delivery: 0 },
              notSubOpts:
                selectedNotSubOpts.value.cnt >= 1
                  ? selectedNotSubOpts.value
                  : { idx: 2, cnt: 0, name: '선택안함', amt: 0, delivery: 0 },
              // eslint-disable-next-line no-use-before-define
              totalAmount: totalAmount.value,
            }
            localStorage.setItem('orderData', JSON.stringify(orderData.value))
            localStorage.setItem('redirectIfFailed', window.location.href)
            router.push({
              path: '/order',
            })
          } else {
            errStatus.value = true
            errCost.value = true
            errMsg.value = '콘텐츠 옵션을 선택해주세요.'
          }
        } else {
          // eslint-disable-next-line no-use-before-define, no-lonely-if
          if (totalAmount.value === 0) {
            errStatus.value = true
            errCost.value = true
            errMsg.value = ' 옵션을 선택한 뒤 구매하기를 선택해 주세요.'
          } else {
            orderData.value = {
              contentsIdx: detailData.value.idx,
              contentsTitle: detailData.value.title,
              contentsAmt: detailData.value.amt,
              // selectedSubOpts,2가 0보다 큰지 확인 >> 구매수량이 1이상인지 체크
              /* 삼항 연산자를 사용해서
                - 0보다 작으면??
                  삭제.
                - 0보다 크면?
                  선택한 값 넣어줌
              */
              // subOpts: selectedSubOpts.value.amt > 0 ? selectedSubOpts.value : null,
              // notSubOpts: selectedNotSubOpts.value.amt > 0 ? selectedNotSubOpts.value : null,
              // selectedSubOpts,2가 0보다 큰지 확인 >> 구매수량이 1이상인지 체크
              /* 삼항 연산자를 사용해서
                - 0보다 작으면??
                  /order페이지에서 처리를 위해 v-if에 설정한 조건값을 넣어줌
                - 0보다 크면?
                  선택한 값 넣어줌
              */
              subOpts:
                selectedSubOpts.value.amt > 0
                  ? selectedSubOpts.value
                  : { idx: 1, cnt: 0, name: '선택안함', amt: 0, delivery: 0 },
              notSubOpts:
                selectedNotSubOpts.value.cnt >= 1
                  ? selectedNotSubOpts.value
                  : { idx: 2, cnt: 0, name: '선택안함', amt: 0, delivery: 0 },
              // notSubOpts:
              //   selectedNotSubOpts.value.amt > 0 &&
              //   selectedNotSubOpts.value.delivery_amt > 0 &&
              //   selectedNotSubOpts.value.cnt >= 1
              //     ? selectedNotSubOpts.value
              //     : { idx: 2, cnt: 0, name: '선택안함', amt: 0, delivery: 0 },

              // notSubOpts:
              //   selectedNotSubOpts.value.amt > 0
              //     ? selectedNotSubOpts.value
              //     : { idx: 2, cnt: 0, name: '선택안함', amt: 0, delivery: 0 },
              // eslint-disable-next-line no-use-before-define
              totalAmount: totalAmount.value,
            }
            localStorage.setItem('orderData', JSON.stringify(orderData.value))
            localStorage.setItem('redirectIfFailed', window.location.href)
            router.push({
              path: '/order',
            })
          }
        }
      } else {
        localStorage.setItem('redirectAfterLogin', window.location.href)
        errStatus.value = true
        errTrigger.value = 'orderTrigger'
        errCost.value = false
        errMsg.value = '로그인 후 시도해주세요.'
      }
    }

    const decodeHtmlContent = (str) => {
      if (str !== undefined && str !== null && str !== '') {
        // eslint-disable-next-line no-param-reassign
        str = String(str)
        // eslint-disable-next-line no-param-reassign
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
        // eslint-disable-next-line no-param-reassign
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
        // eslint-disable-next-line no-param-reassign
        str = str.replace('\n', '<br>')
        const element = document.createElement('div')
        element.innerHTML = str
        // eslint-disable-next-line no-param-reassign
        str = element.textContent
        element.textContent = ''
      }
      return str
    }
    const decodedDescription = computed(() =>
      decodeHtmlContent(detailData.value.description)
    )
    const decodedFeature = computed(() =>
      decodeHtmlContent(detailData.value.feature)
    )

    const updateStatus = () => {
      errStatus.value = false
    }
    onMounted(() => {
      getData()
    })
    watch(() => route.params, getData)

    const subOptsMonth = ref('') // 선택된 콘텐츠의 subs_month
    const notSubOptsMonth = ref('') // 선택된 추가 옵션의 subs_month
    const copynotSubOpts = ref([])
    const filteredNotSubOpts = computed(() => {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      copynotSubOpts.value = notSubOpts.value
      // console.log('testets')
      // console.log('copynotSubOpts.value ::: ', copynotSubOpts.value)
      // notSubOpts가 undefined이거나 null인 경우 빈 배열 반환
      // console.log('notSubOpts(원본 데이터임, 회손되면 안됨.) ::: ', notSubOpts)
      if (!notSubOpts.value || !Array.isArray(notSubOpts.value)) return []
      // 콘텐츠을 선택하지 않은 경우 모든 추가옵션 반환
      if (!subOptsMonth.value) {
        // console.log('콘텐츠이 선택되지 않음, 모든 추가옵션 반환')
        return notSubOpts.value
      }

      // console.log('filteredNotSubOpts 필터링 진행')

      // 1. 콘텐츠의 subs_month와 일치하는 추가옵션 필터링
      const matchingOptions = copynotSubOpts.value.filter(
        (option) => option.subs_month === subOptsMonth.value
      )
      // console.log('matching', matchingOptions)
      // console.log('copynotSubOpts', copynotSubOpts)
      // console.log('notSubOpts222222222222', notSubOpts)

      // 2. 일치하는 추가옵션이 없는 경우, subs_month가 0인 추가옵션 필터링
      if (matchingOptions.length > 0) {
        return matchingOptions // 일치하는 추가옵션이 있으면 그 결과 반환
        // eslint-disable-next-line no-else-return
      } else {
        // 추가옵션 중 subs_month가 0인 항목 찾기
        const zeroMonthOptions = notSubOpts.value.filter(
          (option) => option.subs_month === 0
        )

        // subs_month가 0인 추가옵션이 있으면 그 결과 반환
        return zeroMonthOptions.length > 0 ? zeroMonthOptions : notSubOpts.value // 0이 없으면 모든 추가옵션 반환
      }
    })
    const filteredSubOpts = computed(() => {
      // 초기 상태에서 모든 콘텐츠 표시
      if (!notSubOptsMonth.value) {
        return subOpts.value // 추가 옵션이 선택되지 않은 경우 모든 콘텐츠을 반환
      }
      // 추가 옵션이 선택된 경우 필터링
      return subOpts.value.filter(
        (option) => option.subs_month === notSubOptsMonth.value
      )
    })
    const selectedSub = ref(null) // 선택된 콘텐츠 상태
    const selectedNotSub = ref(null) // 선택된 추가옵션 상태
    const handleSelect = (selected) => {
      // console.log(selected)
      // console.log(selected.subs_month)
      if (selected.is_subs) {
        // 콘텐츠 선택
        subOptsMonth.value = selected.subs_month
        // 콘텐츠 선택 시 해당 옵션을 선택된 옵션으로 설정
        selectedSubOpts.value = {
          ...JSON.parse(JSON.stringify(selected)), // 깊은복사
          cnt: 1, // 기본 수량
        }
        // 추가옵션 필터링
        const matchingNotSubOpts = filteredNotSubOpts.value
        copynotSubOpts.value = matchingNotSubOpts // 필터링된 추가옵션으로 업데이트
      } else {
        // 추가옵션 선택
        notSubOptsMonth.value = selected.subs_month
        if (subOptsMonth.value !== '') {
          // 콘텐츠이 선택된 경우 추가옵션 필터링
          const matchingNotSubOpts = copynotSubOpts.value.filter(
            (option) => option.subs_month === notSubOptsMonth.value
          )
          if (matchingNotSubOpts.length === 0) {
            // subs_month가 0인 경우만 필터링
            copynotSubOpts.value = notSubOpts.value.filter(
              (option) => option.subs_month === 0
            )
          } else {
            // 일치하는 추가옵션이 있을 경우
            copynotSubOpts.value = matchingNotSubOpts // 필터링된 추가옵션으로 업데이트
          }
          // 선택된 추가옵션 상태 설정
          selectedNotSubOpts.value = {
            ...JSON.parse(JSON.stringify(selected)), // 깊은복사
            cnt: 1, // 기본 수량
          }
        } else {
          // 콘텐츠이 선택되지 않은 경우
          selectedNotSubOpts.value = {
            ...JSON.parse(JSON.stringify(selected)), // 깊은복사
            cnt: 1, // 기본 수량
          }
        }
      }
    }
    const totalAmount = computed(() => {
      const subOptionAmount =
        selectedSubOpts.value.disc_rate !== 0
          ? selectedSubOpts.value.disc_amt_drt * selectedSubOpts.value.cnt
          : selectedSubOpts.value.amt * selectedSubOpts.value.cnt

      const notSubOptionAmount =
        selectedNotSubOpts.value.disc_rate !== 0
          ? selectedNotSubOpts.value.disc_amt_drt * selectedNotSubOpts.value.cnt
          : selectedNotSubOpts.value.amt * selectedNotSubOpts.value.cnt

      const subsDelivFee = selectedSubOpts.value.delivery_amt
      const notSubsDelivFee = selectedNotSubOpts.value.delivery_amt
      return (
        (subOptionAmount || 0) +
        (notSubOptionAmount || 0) +
        (subsDelivFee || 0) +
        (notSubsDelivFee || 0)
      )
    })
    // const totalAmount = computed(() => {
    //   const subOptionAmount =
    //     selectedSubOpts.value.disc_rate !== 0
    //       ? selectedSubOpts.value.disc_amt * selectedSubOpts.value.cnt
    //       : selectedSubOpts.value.amt * selectedSubOpts.value.cnt

    //   const notSubOptionAmount =
    //     selectedNotSubOpts.value.disc_rate !== 0
    //       ? selectedNotSubOpts.value.disc_amt * selectedNotSubOpts.value.cnt
    //       : selectedNotSubOpts.value.amt * selectedNotSubOpts.value.cnt

    //   const subsDelivFee = selectedSubOpts.value.delivery_amt
    //   const notSubsDelivFee = selectedNotSubOpts.value.delivery_amt
    //   return (
    //     (subOptionAmount || 0) +
    //     (notSubOptionAmount || 0) +
    //     (subsDelivFee || 0) +
    //     (notSubsDelivFee || 0)
    //   )
    // })
    const updateQuantity = (option, type, amount) => {
      if (type === 'subs') {
        selectedSubOpts.value.cnt = Math.max(
          1,
          (selectedSubOpts.value.cnt || 1) + amount
        )
      } else if (type === 'notsubs') {
        selectedNotSubOpts.value.cnt = Math.max(
          1,
          (selectedNotSubOpts.value.cnt || 1) + amount
        )
      }
    }
    const resetSelection = (type) => {
      if (type === 'subOpts') {
        selectedSub.value = null // 콘텐츠 선택 초기화
        selectedSubOpts.value = { name: '', cnt: 0, amt: 0 }
        subOptsMonth.value = ''
      } else if (type === 'notSubOpts') {
        selectedNotSub.value = null // 추가옵션 선택 초기화
        selectedNotSubOpts.value = { name: '', cnt: 0, amt: 0 }
        notSubOptsMonth.value = ''
      }
    }
    return {
      errMsg,
      errStatus,
      errCost,
      errTrigger,
      errExpire,
      updateStatus,
      contentsId,
      detailData,
      categoryData,
      curriculumData,
      contentNoticeData,
      cNoticeData,
      cNoticePageData,
      getData,
      getIdx,
      moveContent,
      moveToId,
      moveToUrl,
      moveToOrderPage,
      decodeHtmlContent,
      decodedDescription,
      decodedFeature,
      subOpts,
      notSubOpts,
      handleSelect,
      totalAmount,
      currentPage,
      totalPages,
      selectedSubOpts,
      selectedNotSubOpts,
      updateQuantity,
      resetSelection,
      parseCurriculumDetails,
      searchTitle,
      searchContent,
      // metaClientOpen,
      filteredSubOpts,
      filteredNotSubOpts,
    }
  },
}
</script>
